import { openDB } from 'idb';

// let dbIns = null

async function doDatabaseStuff() {
  const dbIns = await openDB('jcb', undefined, {
    upgrade(curr) {
      curr.createObjectStore('projects');
      // db.createObjectStore('projects');
    }
  });
  console.log('..........indexedDB opened..........');
  dbIns.onclose = function () {
    console.log('..........indexedDB closed..........');
  }
  dbIns.onerror = function (...args) {
    console.log('dbIns onerror', ...args)
  }
  return dbIns
}

function getDbIns() {
  return doDatabaseStuff()
}

async function aroundDb(func) {
  const db = await getDbIns()
  const res = await func(db)
  await db.close()
  return res
}

async function getById(storeName, id) {
  // console.log(await getDbIns());
  return aroundDb((db) => {
    return db.get(storeName, id)
  })
}

async function setObject(storeName, obj, id) {
  return aroundDb((db) => {
    return db.put(storeName, obj, id || obj.id)
  })
}

function getProjectById(id) {
  return getById('projects', id)
}

function setProject(project) {
  return setObject('projects', project)
}

async function createStore(storeName, indexs, opt = { keyPath: 'id' }) {
  // console.log('createStore');
  const curr = await getDbIns()
  // console.log(curr, curr.objectStoreNames, storeName, curr.objectStoreNames.contains(storeName));
  if (curr.objectStoreNames.contains(storeName)) {
    return
  }
  await curr.close()
  const dbIns = await openDB('jcb', curr.version + 1, {
    upgrade(next) {
      // console.log(next, oldVersion, newVersion, transaction);
      const store = next.createObjectStore(storeName, opt)
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      indexs && indexs.forEach(p => {
        if (Array.isArray(p)) {
          store.createIndex(p[0], p[0], p[1])
        } else {
          store.createIndex(p, p, { unique: false })
        }
      })
    }
  });
  await dbIns.close()
}

// async function getTransaction(storeName) {
//   return (await getDbIns()).transaction(storeName, 'readwrite')
// }

async function dbTransaction(storeName, func) {
  const db = await getDbIns()
  const tx = db.transaction(storeName, 'readwrite')
  const res = await func(tx)
  await db.close()
  return res
}

// doDatabaseStuff()

export {
  getDbIns,
  getProjectById,
  setProject,
  createStore,
  // getTransaction,
  dbTransaction,
  getById
}
